var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.70898 7.50025H5.83398V10H7.70898V17.5H10.8342V10H13.1105L13.334 7.50025H10.8342V6.45775C10.8342 5.8615 10.9542 5.62525 11.531 5.62525H13.334V2.5H10.9542C8.70648 2.5 7.70898 3.49 7.70898 5.3845V7.4995V7.50025Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialFacebook);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNy43MDg5OCA3LjUwMDI1SDUuODMzOThWMTBINy43MDg5OFYxNy41SDEwLjgzNDJWMTBIMTMuMTEwNUwxMy4zMzQgNy41MDAyNUgxMC44MzQyVjYuNDU3NzVDMTAuODM0MiA1Ljg2MTUgMTAuOTU0MiA1LjYyNTI1IDExLjUzMSA1LjYyNTI1SDEzLjMzNFYyLjVIMTAuOTU0MkM4LjcwNjQ4IDIuNSA3LjcwODk4IDMuNDkgNy43MDg5OCA1LjM4NDVWNy40OTk1VjcuNTAwMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";